import React, { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { ForgetPasswordApi, RequestUnlockOtpApi, VerifyOtpApi, VerifyUnlockOtpApi } from "../../data/userData"; // Import your API functions
import swal from "sweetalert";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import forgotpassword from "../../Assets/Images/support.jpg";
import Swal from "sweetalert2";

// Define a theme with custom styles
const theme = createTheme();

export default function UnlockUserForm() {
  const navigate = useNavigate();
  const [otpRequested, setOtpRequested] = useState(false);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");

  // Called when the user requests an OTP or resends an OTP.
  const handleRequestOtp = async (event) => {
    event.preventDefault();
    if (!email) {
      Swal.fire({
        icon: "warning",
        title: "Email Required",
        text: "Please enter your email before requesting an OTP.",
      });
      return;
    }
    try {
      const response = await RequestUnlockOtpApi(email);
      if (response === "ERR_NETWORK") {
        Swal.fire({
          icon: "error",
          title: "Network Error!",
          text: "Unable to request OTP. Check your internet connection and try again.",
        });
        return;
      }
      if (
        response.code === "ERR_BAD_RESPONSE" ||
        response.code === "ERR_BAD_REQUEST"
      ) {
        if (response.response?.data) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.response.data,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Server Error!",
            text: "Server error, contact Admin",
          });
        }
        return;
      }
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "OTP Sent!",
          text: "Please check your email 📨 for the OTP .",
        });
        setOtpRequested(true);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request . Please try again later.",
      });
    }
  };

  // Called when the user submits the OTP for verification.
  const handleVerifyOtp = async (event) => {
    event.preventDefault();
    if (!email || !otp) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "Please enter both your email and the OTP.",
      });
      return;
    }
    try {
      const response = await VerifyUnlockOtpApi(email, otp);
      if (response === "ERR_NETWORK") {
        Swal.fire({
          icon: "error",
          title: "Network Error!",
          text: "Unable to verify OTP. Check your internet connection and try again.",
        });
        return;
      }
      if (
        response.code === "ERR_BAD_RESPONSE" ||
        response.code === "ERR_BAD_REQUEST"
      ) {
        if (response.response?.data) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.response.data,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Server Error!",
            text: "Server error, contact Admin",
          });
        }
        return;
      }
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Verified!",
          text: "Your OTP has been verified.",
        });
        // Redirect or take further actions here.
        navigate("/login");
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          padding: 2,
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: `url(${forgotpassword})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: 0.8,
            zIndex: -1,
          }}
        ></div>

        <Paper
          component="form"
          noValidate
          onSubmit={otpRequested ? handleVerifyOtp : handleRequestOtp}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: 2,
            borderRadius: "0.5rem",
            backgroundColor: "rgba(255, 255, 255, 0.6)",
            backdropFilter: "blur(2px)",
            width: ["100%", "90%", "70%", "60%"],
            margin: "auto",
            [theme.breakpoints.up("sm")]: {
              width: "90%",
            },
            [theme.breakpoints.up("md")]: {
              width: "60%",
            },
            [theme.breakpoints.up("lg")]: {
              width: "30%",
            },
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            {otpRequested ? "Verify OTP" : "Request OTP"}
          </Typography>
          <TextField
            margin="normal"
            required
            fullWidth
            id="Email"
            label="Email"
            name="Email"
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ marginBottom: 2 }}
          />
          {otpRequested && (
            <TextField
              margin="normal"
              required
              fullWidth
              id="Otp"
              label="OTP"
              name="Otp"
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              sx={{ marginBottom: 2 }}
            />
          )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            {otpRequested ? "Verify OTP" : "Request OTP"}
          </Button>
          {otpRequested && (
            <Button
              fullWidth
              variant="outlined"
              sx={{ mt: 1, mb: 2 }}
              onClick={handleRequestOtp} // Resend OTP when clicked
            >
              Resend OTP
            </Button>
          )}
        </Paper>
      </Box>
    </ThemeProvider>
  );
}
